/**
 * @file view-product-details.tsx
 * @module app/modules/uProcure/products/view-product-details
 * @description Implements the view product details interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import TabPriceDimensions from './product-details-tabs/price-dimensions';
import TabProductDetails from './product-details-tabs/product-details';
import threeDotRound from '../../../../_admin/assets/media/svg_uTrade/three-dot-round.svg';
import APICallService from '../../../../api/apiCallService';
import { inventory, product } from '../../../../api/apiEndPoints';
import Loader from '../../../../Global/loader';
import Notification from '../../../notification/notification';
import { CustomSelectTable } from '../../../custom/Select/CustomSelectTable';
import { error, success } from '../../../../Global/toast';
import ReturnGoodsSellerModal from '../../../modals/return-goods-seller-modal';
import { listMasterProductDetails } from '../../../../utils/storeString';
import { getKey, setKey } from '../../../../Global/history';
import { Edit, MasterProduct } from '../../../../utils/constants';
import { useAuth } from '../../auth';
import Method from '../../../../utils/methods';
// import { warehouse as warehouseStoreString } from '../../../utils/storeString';
import { useWarehouse } from '../../../context/WarehouseContext';
const ViewProductDetails = (props: any) => {

  const { selectedWarehouse } = useWarehouse();
  const { currentUser } = useAuth();
  const { state }: any = useLocation();
  const navigate = useNavigate();
  const [fetchLoader, setFetchLoader] = useState(false);
  const [productDetails, setProductDetails] = useState<any>();
  const [disabledFields, setDisabledFields] = useState([]);
  const [show, setShow] = useState(false);
  const [expired, setExpired] = useState<any>();
  const [expiring, setExpiring] = useState<any>();
  const [productList, setProductList] = useState<any>([]);
  const [modalLoader, setModalLoader] = useState(false);
  const [returnGoodsSeller, setReturnGoodsSeller] = useState(false);
  const handleSelectTab = (tab: any) => {
    setCurrentTab(tab);
    setKey(listMasterProductDetails.currentTab, tab, false);
  };
  useEffect(() => {
    (async () => {
      setFetchLoader(true);
      console.log('hiii master', state);
      await fetchProductDetails();
      setFetchLoader(false);
    })();
  }, []);
  const fetchProductDetails = async () => {
    let apiService = new APICallService(
      product.productInfo,
      state,
      '',
      '',
      '',
      '',
      MasterProduct,
      selectedWarehouse?.value || null
    );
    let response = await apiService.callAPI();
    setProductDetails(response.record);
    let tempFields = response.record.technicalInfo
      .filter((a: any) => a.enabled == false)
      .map((a: any) => a.name);
    setDisabledFields(tempFields);
    setTab([
      {
        name: 'Product details',
        content: <TabProductDetails productDetails={response.record} />,
      },
      {
        name: 'Price & dimensions',
        content: <TabPriceDimensions productDetails={response.record} />,
      },
    ]);
  };
  const [tab, setTab] = useState([
    {
      name: 'Product details',
      content: <TabProductDetails productDetails={productDetails} />,
    },
    {
      name: 'Price & dimensions',
      content: <TabPriceDimensions productDetails={productDetails} />,
    },
  ]);
  const [currentTab, setCurrentTab] = useState<any>(() => {
    const storedTabData = getKey(listMasterProductDetails.currentTab);
    return storedTabData || tab[0];
  });
  const createTabs = () => {
    const localTab = tab;
    let current = currentTab;
    const allTabs = localTab.map((tab) => {
      return (
        <li className="nav-item">
          <Link
            to={'/'}
            className={
              current?.name === tab?.name
                ? 'nav-link active text-active-primary'
                : 'nav-link text-hover-primary'
            }
            data-bs-toggle="tab"
            onClick={() => handleSelectTab(tab)}
          >
            {tab?.name}
          </Link>
        </li>
      );
    });
    return allTabs;
  };
  const renderTabContent = () => {
    const storedTabData: any = getKey(listMasterProductDetails.currentTab);
    if (storedTabData) {
      const currentTabData = tab.find((t) => t.name === storedTabData?.name);
      return currentTabData ? currentTabData.content : null;
    } else {
      return tab[0].content;
    }
  };
  const openMenuOnClick = async () => {
    setShow(true);
  };
  const onMenuClose = async () => {
    setShow(false);
  };
  const onMenuOpen = async () => {
    setShow(true);
  };
  const handleOption = async (event: any) => {
    if (event.value === 1) {
      navigate('/UProcure/products/edit-product-variant', {
        state: {
          _id: state,
          isMaster: false,
          moduleName: MasterProduct,
        },
      });
    } else if (event.value === 2) {
      if (productDetails?.inventoryInfo?.quantityTypes?.length) {
        navigate('/UProcure/inventory/goods-in-warehouse/edit-stock-count', {
          state: state,
        });
      } else {
        error('Stock details not available!');
      }
    }
  };
  const fetchExpiringProducts = async () => {
    setModalLoader(true);
    let apiService = new APICallService(
      inventory.variantExpiredStockList,
      {
        variant: productDetails._id,
      },
      '',
      '',
      '',
      '',
      MasterProduct,
      selectedWarehouse?.value || null
    );
    let response = await apiService.callAPI();
    if (
      (Object.keys(response).length && response.expired.quantityTypes.length) ||
      response.expiring.quantityTypes.length
    ) {
      setProductList(response.businesses);
      setExpired(response.expired);
      setExpiring(response.expiring);
      setReturnGoodsSeller(true);
    } else {
      error('No Data found');
    }
    setModalLoader(false);
  };

  const handleAvailableToSellToggle = async (currentState: boolean) => {
    if (!selectedWarehouse?.value) {
      error("Please select a warehouse first");
      return;
    }
    let apiService = new APICallService(
      product.availableToSell,
      { availableToSell: !currentState },
      {
        variantId: state,
        warehouseId: selectedWarehouse.value,
      },
      "",
      "",
      "",
      MasterProduct,
      selectedWarehouse.value
    );
    let response = await apiService.callAPI();
    if (response) {
      const inventory = productDetails.inventoryInfo || [];
      const warehouseInvIndex = inventory.findIndex(
        (x: any) => x.warehouseId === selectedWarehouse.value
      );
      if (warehouseInvIndex !== -1) {
        inventory[warehouseInvIndex].availableToSell = !currentState;
      } else {
        inventory.push({
          warehouseId: selectedWarehouse.value,
          availableToSell: !currentState,
        });
      }
      setProductDetails({ ...productDetails, inventoryInfo: inventory });
      success(response.message || "ATS status updated successfully");
    }
  };
  return (
    <>
      {productList && productList?.length && returnGoodsSeller ? (
        <ReturnGoodsSellerModal
          show={returnGoodsSeller}
          onHide={() => setReturnGoodsSeller(false)}
          productList={productList}
          expired={expired}
          expiring={expiring}
        />
      ) : (
        <></>
      )}{' '}
      {fetchLoader ? (
        <></>
      ) : (
        <>
          {disabledFields ? (
            <Notification
              iconColor="#ffb302"
              text={`${disabledFields?.map((val: any) => val)?.join(', ')} ${disabledFields?.length == 1 ? 'is' : 'are'
                }
              removed your from product’s technical details as it’s no longer supported in platform.`}
              bgColor="bg-light-warning"
            />
          ) : (
            <></>
          )}
        </>
      )}
      <div className="p-5">
        <Row className="align-items-center mb-7">
          <Col xs>
            <h1 className="fs-22 fw-bolder mb-md-0">Product details</h1>
          </Col>
          {fetchLoader ? (
            <></>
          ) : (
            <>
              <Col xs="auto">
                {Method.hasPermission(MasterProduct, Edit, currentUser) ? (
                  <Button
                    type="button"
                    variant="white"
                    className="uw-btn uw-btn-light uw-btn-icon uw-btn-sm btn-icon btn-sm"
                  >
                    <CustomSelectTable
                      marginLeft={'-56px'}
                      width={'130px'}
                      placeholder={
                        <img
                          className="img-fluid"
                          width={47}
                          height={47}
                          src={threeDotRound}
                          alt=""
                        />
                      }
                      options={[
                        {
                          label: (
                            <Button
                              variant=""
                              className="btn btn-link btn-flush fs-14 fw-500 text-black ms-3 p-4  "
                            >
                              Edit details
                            </Button>
                          ),
                          value: 1,
                        },
                        {
                          label: (
                            <Button
                              variant=""
                              className="btn btn-link btn-flush fs-14 fw-500 text-black ms-3 p-4  "
                            >
                              Edit Stock Count
                            </Button>
                          ),
                          value: 2,
                        },
                      ]}
                      backgroundColor="white"
                      show={show}
                      onMenuClose={() => {
                        onMenuClose();
                      }}
                      openMenuOnClick={() => {
                        openMenuOnClick();
                      }}
                      onMenuOpen={() => {
                        onMenuOpen();
                      }}
                      onChange={(event: any) => {
                        handleOption(event);
                      }}
                    />
                  </Button>
                ) : (
                  <></>
                )}
              </Col>
            </>
          )}
        </Row>
        <Row>
          {fetchLoader ? (
            <>
              <div className="d-flex justify-content-center">
                <Loader loading={fetchLoader} />
              </div>
            </>
          ) : (
            <>
              {productDetails && Object?.keys(productDetails)?.length ? (
                <>
                  <Col sm={12}>
                    <Card className="border border-custom-color mb-5 mb-xl-10">
                      <Card.Body className="pt-9 pb-0">
                        <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
                          <div className="me-9 mb-4">
                            <div className="symbol symbol-150px symbol-lg-200px symbol-fixed border position-relative">
                              <div className="image-input d-flex flex-center rounded w-lg-200px h-lg-200px">
                                <div
                                  style={{
                                    backgroundImage: `url(${productDetails?.media[0]?.url})`,
                                  }}
                                  className="image-input-wrapper shadow-none bgi-contain bgi-position-center min-w-150px min-h-150px w-100 h-100"
                                ></div>
                              </div>
                            </div>
                          </div>
                          <Row className="flex-grow-1 ">
                            <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                              <div className="d-flex flex-column">
                                <div className="d-flex flex-column mb-2">
                                  <div className="d-flex align-items-center">
                                    <h3 className="text-black line-clamp-2 fs-22 fw-700 mb-0">
                                      {productDetails?.title}
                                    </h3>
                                    {productDetails?.active ? (
                                      <span className="badge badge-light-success border-r4px p-3 fs-14 fw-600 text-dark ms-2">
                                        Active
                                      </span>
                                    ) : (
                                      <span className="badge badge-light border-r4px p-3 fs-14 fw-600 text-dark ms-2">
                                        Deactivated
                                      </span>
                                    )}

                                    {Method.hasPermission(
                                      MasterProduct,
                                      Edit,
                                      currentUser
                                    ) && (
                                        <label className="form-check form-switch form-check-custom form-check-solid ms-5">
                                          <input
                                            className="form-check-input form-check-success w-40px h-25px"
                                            type="checkbox"
                                            disabled={!selectedWarehouse?.value}
                                            checked={
                                              productDetails?.inventoryInfo?.find(
                                                (x: any) =>
                                                  x.warehouseId ===
                                                  selectedWarehouse?.value
                                              )?.availableToSell
                                            }
                                            onChange={() =>
                                              handleAvailableToSellToggle(
                                                productDetails?.inventoryInfo?.find(
                                                  (x: any) =>
                                                    x.warehouseId ===
                                                    selectedWarehouse?.value
                                                )?.availableToSell
                                              )
                                            }
                                          />
                                          <span className="fs-14 fw-600 ms-2">
                                            Available to Sell
                                          </span>
                                        </label>
                                      )}
                                  </div>
                                  <span className="fs-16 fw-500 mt-1">
                                    Product ID: {productDetails?.refKey}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </Row>
                        </div>
                      </Card.Body>
                      <Row className="align-items-center px-lg-9 px-6">
                        <Col sm>
                          <div className="d-flex h-70px">
                            <ul className="nav nav-stretch nav-line-tabs nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-transparent fs-18 fw-600">
                              {createTabs()}
                            </ul>
                          </div>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                  <Col lg={12}>
                    <div
                      className="tab-content"
                      id="myTabContent"
                    >
                      <div className="tab-pane fade show active">
                        <>{renderTabContent()}</>
                      </div>
                    </div>
                  </Col>
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </Row>
      </div>
    </>
  );
};
export default ViewProductDetails;
